import React, { memo, useMemo } from 'react';
import { Tabs, Text, Avatar } from '@Sage/hoi-poi-ui';
import classnames from 'classnames';

import './styles.scss';

const GeneralTabs = memo(({ className, tabs, activeKey, onChange, onClose, onSorting }) => {
    const generalTabs = useMemo(() => {
        return tabs.map((tab) => {
            const { tabClassName, title, icon, ...rest } = tab;
            return {
                ...rest,
                title: (
                    <div className={classnames('fm-general-tabs__tab', tabClassName)}>
                        <Avatar icon={icon} />
                        <Text isTruncated>{title}</Text>
                    </div>
                ),
            };
        });
    }, [tabs]);

    const tabClasses = useMemo(
        () => ({
            navContainer: 'fm-general-tabs__nav-container',
            nav: 'fm-general-tabs__nav',
            navWrap: 'fm-general-tabs__nav-wrap',
            tab: 'fm-general-tabs__tab-button',
            tabActive: 'fm-general-tabs__tab-active',
            tabWithPopover: 'fm-general-tabs__tab-with-popover',
            inkBar: 'fm-general-tabs__ink-bar',
            popover: 'fm-general-tabs__popover',
        }),
        [],
    );

    return (
        <Tabs
            className={classnames('fm-general-tabs', className)}
            onChange={onChange}
            onClose={onClose}
            activeKey={activeKey}
            tabs={generalTabs}
            classes={tabClasses}
            editable
            draggable={tabs?.length > 1}
            onSorting={onSorting}
            popoverAlignLeft
        />
    );
});

export default GeneralTabs;
